'use strict'

module.exports = Info

var proto = Info.prototype

proto.space = null
proto.attribute = null
proto.property = null
proto.boolean = false
proto.booleanish = false
proto.overloadedBoolean = false
proto.number = false
proto.commaSeparated = false
proto.spaceSeparated = false
proto.commaOrSpaceSeparated = false
proto.mustUseProperty = false
proto.defined = false

function Info(property, attribute) {
  this.property = property
  this.attribute = attribute
}



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/lib/util/info.js
// module id = 424
// module chunks = 35783957827783 241767136424496